import { ContactFormData } from '../types';

/**
 * API Service for Backend Integration
 * 
 * Base URL is configured from environment variable REACT_APP_API_URL
 * Default: http://localhost:8000
 */

const API_URL: string = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Submit contact form to backend API
 * 
 * @param formData - Contact form data with name, email, message, consent
 * @returns Promise resolving to success message
 * @throws Error if submission fails
 */
export const submitContactForm = async (
  formData: ContactFormData
): Promise<string> => {
  // Filter out empty strings for optional fields
  const payload = {
    ...formData,
    countryCode: formData.countryCode?.trim() || undefined,
    phone: formData.phone?.trim() || undefined,
  };

  const response = await fetch(`${API_URL}/api/contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`Failed to submit form: ${response.statusText}`);
  }

  const data = await response.json();
  return data.data.message;
};

// Export API_URL for configuration reference
export { API_URL };
